import { render, staticRenderFns } from "./jrhy.vue?vue&type=template&id=1a05096d"
import script from "./jrhy.vue?vue&type=script&lang=js"
export * from "./jrhy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports